// extracted by mini-css-extract-plugin
export default {"DefaultSettings":"_DefaultSettings--At6Zp","TemporaryWarning":"_TemporaryWarning--GlrQt","Divider":"_Divider--hNBPT"};